import {
  Box,
  Container,
  FormControl,
  InputAdornment,
  makeStyles,
  OutlinedInput,
  Select,
  TextField,
  Typography,
} from "@material-ui/core";
import React, { useContext, useState } from "react";
import ControlCameraIcon from "@material-ui/icons/ControlCamera";
import DateRangeIcon from "@material-ui/icons/DateRange";
import HomeIcon from "@material-ui/icons/Home";
import LocationOnOutlinedIcon from "@material-ui/icons/LocationOnOutlined";
import "./SearchHeading.css";
import { useLocation, useNavigate } from "react-router-dom";
import { SearchContext } from "../../../../context/SearchContext";
import SearchIcon from "@material-ui/icons/Search";
import Loader from "../../../Pages/Loader/Loader";

const useStyles = makeStyles({});

const SearchHeading = ({ equipmentsData, productData, vehicleData }) => {
  const classes = useStyles();
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  const [transportation, setTransportation] = useState("");
  const [loadingDate, setLoadingDate] = useState("");
  const [productType, setProductType] = useState("");
  const [truckType, setTruckType] = useState("");
  const [weights, setWeights] = useState("");
  const [volume, setVolume] = useState("");
  const [equipments, setEquipments] = useState("");

  const navigate = useNavigate();

  const { dispatch } = useContext(SearchContext);
  const location = useLocation();
  const sliceLocaion = location?.pathname?.split("/");
  console.log("location", sliceLocaion[1]);
  console.log();

  const handleSearch = () => {
    dispatch({
      type: "NEW_SEARCH",
      payload: {
        from,
        to,
        transportation,
        loadingDate,
        productType,
        truckType,
        weights,
        volume,
        equipments,
      },
    });
    navigate("/booking", {
      state: {
        from,
        to,
        transportation,
        loadingDate,
        productType,
        truckType,
        weights,
        volume,
        equipments,
      },
    });
  };
  return (
    <div className="search" style={{ paddingTop: "80px" }}>
      <Container>
        <Box className="side_title">
          <Typography variant="h2">
            Find the best quote for your freight
          </Typography>
        </Box>
        <div className="searchContainer">
          <div className="searchHeading">
            <Box className="">
              <FormControl
                className={(classes.margin, classes.textField)}
                variant="outlined"
              >
                <OutlinedInput
                  id="outlined-adornment-password"
                  type={"text"}
                  required
                  placeholder="From"
                  onChange={(e) => setFrom(e.target.value)}
                  endAdornment={
                    <InputAdornment position="start">
                      <LocationOnOutlinedIcon />
                    </InputAdornment>
                  }
                  labelWidth={0}
                />
              </FormControl>
            </Box>
            <Box className="">
              <FormControl
                className={(classes.margin, classes.textField)}
                variant="outlined"
              >
                <OutlinedInput
                  id="outlined-adornment-password"
                  type={"text"}
                  required
                  placeholder="To"
                  onChange={(e) => setTo(e.target.value)}
                  endAdornment={
                    <InputAdornment position="start">
                      <LocationOnOutlinedIcon />
                    </InputAdornment>
                  }
                  labelWidth={0}
                />
              </FormControl>
            </Box>
            <Box className="borderRight"></Box>
            <Box className="inputIcon">
              <Box>
                <ControlCameraIcon />
              </Box>
              <Box className="search_transportation">
                <span>Transportation Type</span>
                <Select
                  onChange={(e) => setTransportation(e.target.value)}
                  native
                  required
                  inputProps={{
                    name: "age",
                    id: "age-native-simple",
                  }}
                >
                  <option aria-label="None" value="" disabled selected>
                    please select{" "}
                  </option>
                  <option value={"FTL"}>FTL</option>
                  <option value={"LTL"}>LTL</option>
                </Select>
              </Box>
            </Box>
            {sliceLocaion[1] !== "booking" ? (
              <Box className="searchText">
                <button className="common-btn" onClick={handleSearch}>
                  Search
                </button>
              </Box>
            ) : (
              <Box className="searchText">
                <button
                  className="common-btn common_btn_icon"
                  onClick={handleSearch}
                >
                  <SearchIcon />
                </button>
              </Box>
            )}
          </div>
          <div className="headingSearch">
            <Box className="inputIcon">
              <Box>
                <DateRangeIcon />
              </Box>
              <Box>
                <TextField
                  id="date"
                  label="Loading Date"
                  type="date"
                  defaultValue="2022-05-24"
                  onChange={(e) => setLoadingDate(e.target.value)}
                  className={classes.textField}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Box>
            </Box>
            <Box className="borderRight"></Box>
            <Box className="inputIcon">
              <Box>
                <HomeIcon />
              </Box>
              <Box className="search_transportation">
                <span>Product Type</span> <br />
                <Select
                  required
                  onChange={(e) => setProductType(e.target.value)}
                  native
                  inputProps={{
                    name: "age",
                    id: "age-native-simple",
                  }}
                >
                  <option aria-label="None" value="" selected disabled>
                    please select
                  </option>
                  {productData?.map((item) => (
                    <option value={item?.productType} key={item._id}>
                      {item?.productType}
                    </option>
                  ))}
                </Select>
              </Box>
            </Box>
            <Box className="borderRight"></Box>
            <Box className="inputIcon">
              <Box>
                <ControlCameraIcon />
              </Box>
              <Box className="search_transportation">
                <span>Container/Truck Type</span> <br />
                <Select
                  required
                  onChange={(e) => setTruckType(e.target.value)}
                  native
                  inputProps={{
                    name: "age",
                    id: "age-native-simple",
                  }}
                >
                  <option aria-label="None" value="" selected disabled>
                    please select
                  </option>
                  {vehicleData?.map((item) => (
                    <option value={item?.vehicleType} key={item._id}>
                      {item?.vehicleType}
                    </option>
                  ))}
                </Select>
              </Box>
            </Box>
            <Box className="borderRight"></Box>
            <Box className="inputIcon">
              <Box>
                <ControlCameraIcon />
              </Box>
              <Box>
                <TextField
                  required
                  id="standard-helperText"
                  label="Weight, MT"
                  defaultValue="20,000 MT"
                  onChange={(e) => setWeights(e.target.value)}
                />
              </Box>
            </Box>
            <Box className="borderRight"></Box>
            <Box className="inputIcon">
              <Box>
                <ControlCameraIcon />
              </Box>
              <Box>
                <TextField
                  required
                  id="standard-helperText"
                  label="Volume (m3)"
                  defaultValue="45"
                  onChange={(e) => setVolume(e.target.value)}
                />
              </Box>
            </Box>
            <Box className="borderRight"></Box>
            <Box className="inputIcon">
              <Box>
                <ControlCameraIcon />
              </Box>
              <Box className="search_transportation">
                <span>Equipments</span> <br />
                <Select
                  required
                  onChange={(e) => setEquipments(e.target.value)}
                  native
                  inputProps={{
                    name: "age",
                    id: "age-native-simple",
                  }}
                >
                  <option aria-label="None" value="" selected disabled>
                    please select
                  </option>
                  {equipmentsData?.map((item) => (
                    <option value={item?.equipmentType} key={item._id}>
                      {item?.equipmentType}
                    </option>
                  ))}
                </Select>
              </Box>
            </Box>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default SearchHeading;
